//菜单管理
import { $http, buildHeaders } from "./index";

//获取菜单树
export const menu_tree = () => {
  return $http.get("/admin/Menu/tree");
};

//获取菜单列表
export const menu_list = (params) => {
  return $http.get("/admin/Menu/index", { params });
};

//获取菜单详情
export const menu_detail = (id) => {
  return $http.get("/admin/Menu/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加菜单
export const menu_add = (data) => {
  return $http.post("/admin/Menu/add", data, {
    headers: buildHeaders(3),
  });
};

//修改菜单
export const menu_edit = (data) => {
  return $http.post("/admin/Menu/edit", data, {
    headers: buildHeaders(3),
  });
};

//菜单启停
export const menu_qt = (data) => {
  return $http.post("/admin/Menu/updateShow", data, {
    headers: buildHeaders(3),
  });
};

//删除菜单
export const menu_delete = (id) => {
  return $http.post(
    "/admin/Menu/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
